import { Controller } from '@hotwired/stimulus'
import Chart from 'chart.js/auto'

// stats-chart Controller
export default class extends Controller {
  static values = { url: String }

  connect() {
    this.loadChart()
  }

  loadChart() {
    fetch(this.urlValue)
      .then(response => response.json())
      .then(data => this.renderChart(data))
      .catch(error => console.error('Cannot load stats:', error))
  }

  createGradient(ctx, chart, color) {
    const chartArea = chart.chartArea
    if (!chartArea) return color

    const gradient = ctx.createLinearGradient(0, chartArea.top, 0, chartArea.bottom)
    gradient.addColorStop(0, color)
    gradient.addColorStop(0.7, color)
    gradient.addColorStop(1, 'rgba(255, 255, 255, 0)')
    return gradient
  }

  renderChart(data) {
    if (!data.views.length) {
      return
    }

    const ctx = this.element.getContext('2d')

    if (this.chartInstance) {
      this.chartInstance.destroy()
    }

    this.chartInstance = new Chart(ctx, {
      type: 'line',
      data: {
        labels: data.labels,
        datasets: [
          {
            label: 'Vues',
            data: data.views,
            borderColor: '#0066ff',
            backgroundColor: context => this.createGradient(context.chart.ctx, context.chart, 'rgba(0, 102, 255, 0.3)'),
            fill: true,
            pointRadius: 0
          },
          {
            label: 'Interactions',
            data: data.interactions,
            borderColor: '#ff4500',
            fill: false,
            pointRadius: 0
          }
        ]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: false
          },
          tooltip: {
            enabled: true,
            mode: 'nearest',
            intersect: false,
            backgroundColor: '#23232390',
            titleFont: { weight: 'bold', size: 14, color: '#ffffff' },
            bodyFont: { size: 12, color: '#ffffff' },
            padding: 10,
            cornerRadius: 6,
            callbacks: {
              title(context) {
                return context[0].label
              },
              label(context) {
                const value = context.raw.toLocaleString('fr-FR')
                const datasetLabel =
                  context.datasetIndex === 0
                    ? context.raw > 1
                      ? ' vues'
                      : ' vue'
                    : context.raw > 1
                    ? ' interactions'
                    : ' interaction'
                return ` ${value}${datasetLabel}`
              },
              labelColor(context) {
                return {
                  backgroundColor: context.datasetIndex === 0 ? '#0066ff' : '#ff4500',
                  borderWidth: 0,
                  borderRadius: 4
                }
              }
            }
          }
        },
        scales: {
          y: {
            min: 0,
            ticks: {
              callback(value) {
                if (value >= 1000) {
                  return `${(value / 1000).toFixed(0)}K`
                }
                return value.toLocaleString()
              },
              padding: 5,
              maxTicksLimit: 5
            },
            border: {
              display: false,
              dash: [5, 5],
              dashOffset: 6
            },
            grid: {
              drawBorder: false
            }
          },
          x: {
            ticks: {
              padding: 5,
              maxTicksLimit: 7
            },
            grid: {
              drawBorder: false,
              display: false
            }
          }
        }
      }
    })
  }
}
